<template lang="pug">
form(@submit.prevent="onSubmit")
  .form-group(v-if="Object.keys(errors).length")
    .alert.error_explanation
      form-error(:errors="errors")

  div
    .inline-block.border-2.border-gray-400.relative.text-base.text-gray.font-normal.py-select.px-8.text-left.rounded.leading-10.overflow-hidden(v-if="subjects.length > 0")
      select.bg-transparent.appearance-none.w-40(v-model="contact.subject")
        option(v-for="(subject, index) in subjects" :key="index" :value="subject.value") {{ subject.label }}
      span.fal.fa-chevron-down.text-lg.text-primary.font-medium

    .grid.grid-cols-1.gap-0(class="lg:gap-6 lg:grid-cols-2")
      .form-group
        input#contact_lastname.form-control(v-model="contact.lastname" type="text" required="required" placeholder="Nom" :class="{'field_with_errors': errors.lastname}")

      .form-group
        input#contact_firstname.form-control(v-model="contact.firstname" type="text" required="required" placeholder="Prénom" :class="{'field_with_errors': errors.firstname}")

    .grid.grid-cols-1.gap-0(class="lg:gap-6 lg:grid-cols-2")
      .form-group
        input#contact_phone.form-control(v-model="contact.phone" type="phone" required="required" placeholder="Téléphone" :class="{'field_with_errors': errors.base}")

      .form-group
        input#contact_email.form-control(v-model="contact.email" type="email" required="required" placeholder="E-mail" :class="{'field_with_errors': errors.base}")

    .grid.grid-cols-1.gap-3(class="lg:gap-6")
      textarea#contact_message.form-control(v-model="contact.message" rows="8" required="required" placeholder="Message" :class="{'field_with_errors': errors.message}")

    .mt-8(class="xl:flex")
      div
        label(class="checkbox-native inline-block font-sans relative pl-10 mr-12 text-xs font-light text-gray-800 cursor-pointer select-none")
          span En soumettant ce formulaire, j’accepte que les informations saisies dans ce formulaire soient utilisées, exploitées, traitées pour permettre de me recontacter. Découvrez comment nous recueillons, utilisons et partageons vos données en lisant notre Politique d’utilisation des données.
          input(class="checkbox-native__input absolute opacity-0 cursor-pointer h-0 w-0" type="checkbox" name="rgpd_terms_accepted" value="true" v-model="contact.rgpd_terms_accepted")
          span(class="checkbox-native__checkmark absolute top-2 transform left-0 w-6 h-6 border border-black rounded-sm")

      .mt-12.text-center(class="xl:mt-0 xl:ml-12 xl:text-left")
        vue-recaptcha(
          ref="recaptcha"
          size="invisible"
          :sitekey="recaptchaAppKey"
          @verify="onCaptchaVerify"
          @expired="onCaptchaExpired"
        )

        input(type="submit" :id="submitButtonId" :disabled="!canSubmit" value="Envoyer" class="btn btn-lg btn-primary")
  </template>

<script>
import axios from 'axios'
import { VueRecaptcha } from 'vue-recaptcha'
import FormError from '@components/FormError'

export default {
  components: {
    VueRecaptcha,
    FormError
  },

  props: {
    recaptchaAppKey: {
      type: String,
      required: true
    },

    redirectOnSubmit: {
      type: String,
      default: '/contacts'
    },

    contactable: {
      type: Object,
      default () { return {} }
    },

    subjects: {
      type: Array,
      default: () => []
    },

    submitButtonId: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      contact: {
        lastname: '',
        firstname: '',
        email: '',
        phone: '',
        message: '',
        subject: null,
        contactable_type: this.contactable.contactable_type,
        contactable_id: this.contactable.contactable_id,
        rgpd_terms_accepted: this.rgpd_terms_accepted,
        url: window.location.href
      },
      errors: [],
      isSubmitting: false
    }
  },

  computed: {
    canSubmit () {
      return !!(
        this.contact.firstname &&
        this.contact.lastname &&
        this.contact.phone &&
        this.contact.email &&
        this.contact.message &&
        this.contact.rgpd_terms_accepted
      )
    }
  },

  mounted () {
    this.contact.subject = this.subjects.length > 0 ? this.subjects[0].value : null
  },

  methods: {
    onSubmit () {
      this.$refs.recaptcha.execute()
    },

    onCaptchaVerify (recaptchaToken) {
      this.isSubmitting = true
      this.$refs.recaptcha.reset()

      this.errors = []

      axios.post('/api/v1/contacts', {
        contact: this.contact,
        'g-recaptcha-response': recaptchaToken
      })
        .then(() => {
          window.location.href = this.redirectOnSubmit
        })
        .catch(({ response: { data } }) => {
          this.isSubmitting = false
          this.errors = data.errors.data.attributes.errors
        })
    },

    onCaptchaExpired () {
      this.$refs.recaptcha.reset()
    }
  }
}
</script>
